import { MakeRequired } from '@shared/typeHelpers'
import { TrashIcon } from '@ui-components/assets/Icons'
import { useIsDesktopScreen } from '@ui-components/hooks/useIsDesktopScreen'

import { Button, ButtonProps } from '../Button'

type SelectedButtonProps = Pick<ButtonProps, 'aria-label' | 'data-testid' | 'label' | 'onClick' | 'type'>
export type RemoveItemButtonProps = MakeRequired<SelectedButtonProps, 'aria-label'>

export const RemoveItemButton = (props: RemoveItemButtonProps) => {
  const isDesktop = useIsDesktopScreen()
  return <Button icon={<TrashIcon />} iconOnly={!isDesktop} variant="secondary" {...props} />
}
